import smoothscroll from 'smoothscroll-polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import { useDispatch } from 'react-redux';

import 'normalize.css';
import './style/global.css';
import 'react-table-6/react-table.css';

import { wireUpInternals } from './internals/wireUpInternals';
import { store } from './internals/store';
import { history } from './internals/history';
import zendesk from './internals/zendesk';

import { AppRoutes } from './AppRoutes';
import { sendHibernationAnalyticsTrigger } from './utils/analytics.utils';

import type { AppDispatch } from './types/state.types';

window.sesamBasename = import.meta.env.BASE_URL;

const baseUrlElement = document.getElementById('baseUrl') as HTMLBaseElement;

if (baseUrlElement) {
  baseUrlElement.href = import.meta.env.BASE_URL ?? '/';
}

export const useAppDispatch = () => useDispatch<AppDispatch>();

// Wire up all non-React components
// Kind of a hacky way to use Redux, but it works
wireUpInternals(store);

// Expose store for Cypress E2E tests
if ((window as any).Cypress) {
  (window as any).__store = store;
}

// Wire up Google Analytics and Zendesk to the browser history
history.listen((location) => {
  const pathname = location.pathname;
  zendesk.updatePath(pathname);

  // Sending an analytics signal to the portal on a subscription page view.
  const portalUrl = store.getState().globals.portalUrl;
  sendHibernationAnalyticsTrigger(portalUrl);
});

// Whatever Zendesk and Smoothscroll packages need
zendesk.polyfill();
smoothscroll.polyfill();

ReactDOM.render(<AppRoutes store={store} history={history} />, document.getElementById('app'));
